import { PdfH1 } from 'pages/v2/compiler/PDF/Styles.styled';
import React from 'react';
import DynamicContentRenderer from '../DynamicContentRenderer';

const PdfH1Renderer: React.FC<any> = ({ children, header }) => {
  return (
    <>
      {header && <PdfH1>{header}</PdfH1>}
      <DynamicContentRenderer schema={children} />
    </>
  );
};

export default PdfH1Renderer;
